import React from 'react';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';
import { motion } from 'framer-motion';

interface ErrorStateProps {
  title?: string;
  message?: string;
  error?: string | Error;
  onRetry?: () => void;
  retryText?: string;
  variant?: 'default' | 'admin' | 'user';
  showRetry?: boolean;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Bir Hata Oluştu',
  message,
  error,
  onRetry,
  retryText = 'Tekrar Dene',
  variant = 'default',
  showRetry = true,
  className = '',
}) => {
  const getErrorMessage = () => {
    if (message) {
      return message;
    }
    if (error) {
      return typeof error === 'string' ? error : error.message;
    }
    return 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';
  };

  const getVariantClasses = () => {
    switch (variant) {
      case 'admin':
        return 'text-blue-600';
      case 'user':
        return 'text-green-600';
      default:
        return 'text-red-600';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`text-center py-8 ${className}`}
    >
      <FaExclamationTriangle className={`mx-auto text-4xl ${getVariantClasses()} mb-4`} />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-4 max-w-md mx-auto">{getErrorMessage()}</p>
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
        >
          <FaRedo className="text-sm" />
          {retryText}
        </button>
      )}
    </motion.div>
  );
};

export const AdminErrorState: React.FC<Omit<ErrorStateProps, 'variant'>> = props => (
  <ErrorState {...props} variant="admin" />
);
